function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo } from 'react';
import { useCreateStore, Validozer } from 'formydable';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FormCore from './FormCore';
import Input from './Input';
import BooleanField from './Boolean';
import Condition from './Condition';
import States from './States';
import SpreadSheet from './SpreadSheet';
import Grid from './GridField';
import SingleFieldInObjectArray from './SingleFieldInObjectArray';
import FieldArray from './FieldArray';
import FieldArrayMultiple from './FieldArrayMultiple';
import InputWithAdd from './InputWithAdd';
import Submit from './Submit';
import setBackendValidation from './setBackendValidation';
import './customize-field.scss';
export * from './FormCore';
export * from './SpreadSheet';
export * from './GridField';
export * from './SingleFieldInObjectArray';
export * from './FieldArray';
export * from './FieldArrayMultiple';
export * from './SingleFieldInObjectArray';
export * from './InputWithAdd';
//@ts-ignore
const FormManager = /*#__PURE__*/memo(props => {
  const value = useCreateStore();
  return /*#__PURE__*/React.createElement(FormCore, _extends({
    value: {
      store: value
    }
  }, props));
});
FormManager.Submit = Submit;
FormManager.Boolean = BooleanField;
FormManager.Input = Input;
FormManager.InputWithAdd = InputWithAdd;
FormManager.SingleFieldInObjectArray = SingleFieldInObjectArray;
FormManager.Core = FormCore;
FormManager.Condition = Condition;
FormManager.States = States;
FormManager.SpreadSheet = SpreadSheet;
FormManager.Grid = Grid;
FormManager.FieldArray = FieldArray;
FormManager.FieldArrayMultiple = FieldArrayMultiple;
FormManager.Row = Row;
FormManager.Col = Col;
FormManager.setBackendValidation = setBackendValidation;
Validozer.rulesExtend({
  required_number: {
    message: "':attribute' is required and missing",
    exe: ({
      received
    }) => typeof received !== 'number'
  },
  required_object: {
    message: "':attribute' is required and missing",
    exe: ({
      received
    }) => !received
  },
  required_file_url: {
    message: "':attribute' is required and missing",
    exe: ({
      received
    }) => !received || Array.isArray(received) && received.length === 0
  },
  not_includes_number: {
    message: "':attribute' is not available",
    exe: ({
      received,
      parameter
    }) => (parameter || '').split(',').map(each => parseFloat(each)).includes(received)
  },
  not_includes: {
    message: "':attribute' is not available",
    exe: ({
      received,
      parameter
    }) => (parameter || '').split(',').map(each => each.trim()).includes(received)
  },
  custom_mimes: {
    message: 'The :attribute only allows :custom_mimes.',

    exe({
      received,
      parameter
    }) {
      return !Array.from(received).every(file => {
        const filename = file.split('.');
        return parameter.includes(filename[filename.length - 1].toLowerCase());
      });
    }

  },
  max_size_md: {
    exe({
      received,
      parameter
    }) {
      const max_size = parseInt(parameter) * 1000;
      return received.length && Array.from(received).some(value => value.size / 1000 > max_size);
    },

    message: 'The :attribute must not be greater than `:max_size_md MB`'
  },
  min_size_md: {
    exe({
      received,
      parameter
    }) {
      const max_size = parseInt(parameter) * 1000;
      return received.length && Array.from(received).some(value => value.size / 1000 < max_size);
    },

    message: 'The :attribute must not be less than `:min_size_md MB`'
  }
});
Validozer.rulesUpdateMessage("required", "':attribute' is required and missing");
export default FormManager;